import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, listField } from './util';
import { Organization } from './organization';
import { File } from './file';
import { Sport } from './sport';


@ModelInstance({
  mappingFields: {
    id: 'id',
    logo: 'logo',
    contact_email: 'contactEmail',
    contact_phone: 'contactPhone',
    name: 'name',
    alias: 'alias',
    domain: 'domain',
    sport: 'sport',
    description: 'description',
    social_links: 'socialLinks',
    links: 'links',
    organization: 'organization',
    tournaments_count: 'tournamentsCount',
    documents_count: 'documentsCount',
    closest_game_datetime: 'closestGameDatetime',
    cover: 'cover',
    cover_mobile: 'coverMobile',
    about: 'about',
    locale: 'locale',
  },
  relation: {
    organization: Organization,
    logo: File,
    cover: File,
    coverMobile: File,
    sport: Sport,
  }
})
export class League extends BaseModel {
  id: number;
  logo: File;
  contactEmail: string;
  contactPhone: string;
  name: string;
  alias: string;
  domain: string;
  sport: Sport;
  description: string;
  socialLinks: string[];
  links: string[];
  organization: Organization;
  tournamentsCount: number;
  documentsCount: number;
  closestGameDatetime: string;
  cover: File;
  coverMobile: File;
  about: string;
  locale: string;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}

  get vkLink(): string {
    return this.socialLinks.find(link => link.indexOf('vk.com/') > -1);
  }

  get fbLink(): string {
    return this.socialLinks.find(link => link.indexOf('facebook.com/') > -1);
  }

  get instaLink(): string {
    return this.socialLinks.find(link => link.indexOf('instagram.com/') > -1);
  }

  get youtubeLink(): string {
    return this.socialLinks.find(link => link.indexOf('youtube.com/') > -1);
  }

  get telegramLink(): string {
    return this.socialLinks.find(link =>
      link.substr(0, 13) === 'https://t.me/' ||
      link.substr(0, 17) === 'https://www.t.me/'
    );
  }

  get tiktokLink(): string {
    return this.socialLinks.find(link => link.indexOf('tiktok.com/') > -1);
  }

  checkRuDomain(): boolean {
    const domainSplit = this.domain.split('.');
    return domainSplit[(domainSplit.length - 1)] === 'ru';
  }
}
